import { render, staticRenderFns } from "./CustomSnackbar.vue?vue&type=template&id=2ea34123&scoped=true"
import script from "./CustomSnackbar.vue?vue&type=script&lang=js"
export * from "./CustomSnackbar.vue?vue&type=script&lang=js"
import style0 from "./CustomSnackbar.vue?vue&type=style&index=0&id=2ea34123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea34123",
  null
  
)

export default component.exports